import React from "react";
import { usePasswordVisibility } from "./usePasswordVisibility";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ValueObject } from "../../types";
import { Icon, IconType } from "../Icon";
import { Icons } from "../../utils";

interface InputWithStartIconProps {
  placeholder?: string;
  type?: string;
  name: keyof ValueObject & string;
  iconName: string;
  iconType: IconType;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  valueObject: ValueObject;
  error?: boolean;
  errorMessage?: string;
}

export const InputWithStartIcon: React.FC<InputWithStartIconProps> = ({
  placeholder = "",
  type = "text",
  name,
  iconName,
  iconType,
  handleChange,
  valueObject,
  error,
  errorMessage,
}) => {
  const { t } = useTranslation();
  const { isPasswordVisible, togglePasswordVisibility, inputRef } = usePasswordVisibility();

  const isPasswordType = type === "password";

  const handleClickShowPassword = togglePasswordVisibility;

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <TextField
      label=""
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Icon name={iconName} type={iconType} />
          </InputAdornment>
        ),
        endAdornment: isPasswordType ? (
          <InputAdornment position="end">
            <IconButton
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
              style={{ marginRight: "-4px" }}
            >
              {isPasswordVisible ? (
                <Icon name={Icons.hidePassword} />
              ) : (
                <Icon name={Icons.showPassword} />
              )}
            </IconButton>
          </InputAdornment>
        ) : null,
        placeholder: t(placeholder),
        type: isPasswordType ? (isPasswordVisible ? "text" : "password") : type,
        name,
        inputRef: isPasswordType ? inputRef : undefined,
      }}
      value={valueObject ? valueObject[name] : ""}
      onChange={handleChange}
      error={error}
      helperText={errorMessage}
      color="info"
    />
  );
};
